import React from 'react';
import { CheckCircle, XCircle, ArrowUpCircle } from 'lucide-react';

// Admin dashboard "upgrades" tab (extracted from AdminPage).
export const AdminUpgradesTab = ({
  formatDate,
  handleApproveUpgrade,
  handleRejectUpgrade,
  upgradeRequests,
  user,
  videos,
}) => (
  <div className="space-y-6">
    {/* Pending Upgrade Requests */}
    <div className="bg-zinc-900/50 rounded-xl border border-zinc-800 overflow-hidden">
      <div className="px-5 py-4 border-b border-zinc-800">
        <h3 className="font-semibold flex items-center gap-2">
          <ArrowUpCircle className="w-5 h-5 text-orange-400" />
          Pending Artist Upgrade Requests ({upgradeRequests.length})
        </h3>
      </div>

      {upgradeRequests.length === 0 ? (
        <div className="px-5 py-12 text-center">
          <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-3" />
          <p className="text-zinc-400">No pending upgrade requests</p>
        </div>
      ) : (
        <div className="divide-y divide-zinc-800">
          {upgradeRequests.map((request) => (
            <div key={request.id} className="px-5 py-4">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-medium text-white">{request.username}</span>
                    <span className="text-zinc-500 text-sm">({request.user_email})</span>
                  </div>
                  {request.reason ? (
                    <p className="text-sm text-zinc-400 mb-2 bg-zinc-800 rounded-lg p-3 mt-2">
                      "{request.reason}"
                    </p>
                  ) : (
                    <p className="text-sm text-zinc-500 italic">No reason provided</p>
                  )}
                  <p className="text-xs text-zinc-500">
                    Requested {formatDate(request.created_at)}
                  </p>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => handleApproveUpgrade(request.id)}
                    className="px-4 py-2 rounded-lg bg-green-500/20 text-green-400 hover:bg-green-500/30 flex items-center gap-2"
                    data-testid={`approve-upgrade-${request.id}`}
                  >
                    <CheckCircle className="w-4 h-4" />
                    Approve
                  </button>
                  <button
                    onClick={() => handleRejectUpgrade(request.id)}
                    className="px-4 py-2 rounded-lg bg-red-500/20 text-red-400 hover:bg-red-500/30 flex items-center gap-2"
                    data-testid={`reject-upgrade-${request.id}`}
                  >
                    <XCircle className="w-4 h-4" />
                    Reject
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

    {/* Info Box */}
    <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-5">
      <div className="flex items-start gap-3">
        <ArrowUpCircle className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
        <div>
          <h4 className="font-medium text-blue-400 mb-1">About Artist Upgrades</h4>
          <p className="text-sm text-zinc-400">
            Listeners can request to become Artists from their Profile page. Artists can upload videos, 
            view analytics, and receive tips. You can also directly set a user's role in the Users tab.
          </p>
        </div>
      </div>
    </div>
  </div>
);
